export const SECOND = 1;
export const MINUTE = SECOND * 60;
export const HOUR = MINUTE * 60;
export const DAY = HOUR * 24;
export const MONTH = DAY * 30;

export const CLOSE_TIME = ', 17:00';
export const CLOSE_TIME_EN = ', 08:00 GMT+0';
